import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { client } from '../graphql/client';
import { store, resetApp } from '../store/configureStore';

/**
 * A central hook to catch unauthorized errors from GraphQL or MFE network requests.
 * Listens for the globally dispatched 'app-unauthorized' custom event.
 */
export function useAuthErrorHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => {
      // Clear all authentication tokens securely
      localStorage.removeItem('auth_token');
      localStorage.removeItem('token_type');
      localStorage.removeItem('google_oauth_connected');
      localStorage.removeItem('google_oauth_just_connected');
      localStorage.removeItem('google_oauth_failed_message');
      
      // Clear apollo cache and reset redux state
      client.clearStore().catch(() => {});
      store.dispatch(resetApp());
      
      // Notify authentication state listeners immediately
      window.dispatchEvent(new CustomEvent('auth:changed'));
      
      // Navigate to login page
      navigate('/login', { replace: true });
    };

    // The event is emitted by Apollo's errorLink or global fetch interceptor on 401
    window.addEventListener('app-unauthorized', handleUnauthorized);

    return () => {
      window.removeEventListener('app-unauthorized', handleUnauthorized);
    };
  }, [navigate]);
}
